import firebase from "config/firebase";
import { toast } from "react-toastify";

let unsubscribe = null;

export const getReadNotifications =
  (schoolId, lastDoc, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("school_notifications")
        .where("isRead", "array-contains", schoolId)
        .orderBy("createdAt", "desc")
        .limit(10);

      if (lastDoc) {
        query = query.startAfter(lastDoc);
      }

      if (unsubscribe) {
        unsubscribe();
      }

      unsubscribe = query.onSnapshot(async (snapshot) => {
        const notifications = [];

        for (const doc of snapshot.docs) {
          const notificationData = { id: doc.id, ...doc.data() };
          console.log("notificationData: ", notificationData);
          const contestId = notificationData.contestId;

          try {
            const userSnapshot = await firebase
              .firestore()
              .collection("contest")
              .doc(contestId)
              .get();

            if (userSnapshot.exists) {
              notificationData.contestData = {
                id: userSnapshot.id,
                ...userSnapshot.data(),
              };
            } else {
              notificationData.contestData = null;
            }
          } catch (userErr) {
            console.error("Error fetching athlete user:", userErr);
            notificationData.athleteData = null;
          }

          notifications.push(notificationData);
        }
        const payload = {
          data: notifications,
          hasMoreDocument: snapshot.docs.length === 10,
          lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
        };
        dispatch({
          type: lastDoc
            ? "LOAD_MORE_READ_NOTIFICATIONS"
            : "GET_READ_NOTIFICATIONS",
          payload,
        });

        onSuccess();
      });
    } catch (error) {
      console.error("Error listening to read notifications:", error);
      toast.error("Failed to listen to notifications");
    }
  };

let contestUnsubscribes = [];
let unsubscribeSnapshot = null;

export const getUnreadNotifications =
  (schoolId, lastVisible, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const baseQuery = firebase
        .firestore()
        .collection("school_notifications")
        .orderBy("createdAt", "desc")
        .limit(10);

      const query = lastVisible ? baseQuery.startAfter(lastVisible) : baseQuery;

      if (unsubscribeSnapshot) unsubscribeSnapshot();
      contestUnsubscribes.forEach((unsub) => unsub());
      contestUnsubscribes = [];

      unsubscribeSnapshot = query.onSnapshot(async (snapshot) => {
        const notifications = [];
        const contestIds = [];

        snapshot.forEach((doc) => {
          const data = doc.data();
          const isRead = data.isRead || [];

          if (!isRead.includes(schoolId)) {
            notifications.push({ id: doc.id, ...data });
            if (data.contestId && !contestIds.includes(data.contestId)) {
              contestIds.push(data.contestId);
            }
          }
        });

        const contestSnapshots = await Promise.all(
          contestIds.map((id) =>
            firebase.firestore().collection("contest").doc(id).get()
          )
        );

        const contestsMap = {};
        contestSnapshots.forEach((doc) => {
          if (doc.exists) {
            contestsMap[doc.id] = { id: doc.id, ...doc.data() };
          }
        });

        const mergedData = notifications.map((notif) => ({
          ...notif,
          contestData: contestsMap[notif.contestId] || null,
        }));

        const payload = {
          data: mergedData,
          hasMoreDocument: snapshot.size === 10,
          lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
        };

        dispatch({
          type: lastVisible
            ? "LOAD_MORE_UNREAD_NOTIFICATIONS"
            : "GET_UNREAD_NOTIFICATIONS",
          payload,
        });

        onSuccess();
      });
    } catch (error) {
      console.error("Error in fetching notifications:", error);
      toast.error("Notifications fetch failed");
    }
  };

export const markNotificationAsRead = (
  docId,
  schoolId,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      const data = {
        isRead: firebase.firestore.FieldValue.arrayUnion(schoolId),
      };

      await firebase
        .firestore()
        .collection("school_notifications")
        .doc(docId)
        .update(data);
      onSuccess();
    } catch (error) {
      console.error("🔥 Error updating isRead:", error);
    }
  };
};

export const updateUserDeviceToken = (token, userId) => {
  return async (dispatch) => {
    try {
      await firebase.firestore().collection("users").doc(userId).update({
        fcmToken: token,
      });

      const updatedDoc = await firebase
        .firestore()
        .collection("users")
        .doc(userId)
        .get();

      const updatedUser = { id: updatedDoc.id, ...updatedDoc.data() };

      dispatch({
        type: "UPDATE_USER_DEVICE_TOKEN",
        payload: updatedUser,
      });

      console.log("✅ Token successfully updated in Firestore & Redux.");
    } catch (error) {
      console.error("🔥 Error updating device token:", error);
    }
  };
};
